export enum ACTIONS {
  INITIAL_DATA = "INITIAL_DATA",
  SET_OBSERVATION_DATE = "SET_OBSERVATION_DATE",
  SET_SITE = "SET_SITE",
  SET_COURSE = "SET_COURSE",
  SET_SELECTED_COACH = "SET_SELECTED_COACH",
  SET_SELECTED_LEARNER = "SET_SELECTED_LEARNER",
  SET_MRN = "SET_MRN",
  SET_SPECIES = "SET_SPECIES",
  SET_SEX = "SET_SEX",
  SET_COMPETENCY_SKILLS = "SET_COMPETENCY_SKILLS",
  SET_ASK = "SET_ASK",
  SET_DISCUSS = "SET_DISCUSS",
  SET_NOTES = "SET_NOTES",
  SET_TIMER_DATA = "SET_TIMER_DATA",
  SET_PET_NAME = "SET_PET_NAME",
  SET_NAME = "SET_NAME",
  SET_SELECTED_OPTION = "SET_SELECTED_OPTION",
  SET_PERFORM = "SET_PERFORM",
  SET_RATE = "SET_RATE",
  SET_COACH_OBSERVE = "SET_COACH_OBSERVE",
  SET_SELECTED_FOCUS_FEEDBACK = "SET_SELECTED_FOCUS_FEEDBACK",
  SET_COACH_AVAILABLE = "SET_COACH_AVAILABLE",
  SET_COACH_RATE = "SET_COACH_RATE",
  SET_CASE_DATE = "SET_CASE_DATE",
  SET_CASE_TIME = "SET_CASE_TIME",
  SET_PET_FIRST_NAME = "SET_PET_FIRST_NAME",
  SET_PET_LAST_NAME = "SET_PET_LAST_NAME",
  SET_ITER_SUB_REQUIREMENT_RATE = "SET_ITER_SUB_REQUIREMENT_RATE",
  SET_ITER_SUB_REQUIREMENT_COACH_RATE = "SET_ITER_SUB_REQUIREMENT_COACH_RATE",
  SET_ITER_SUB_REQUIREMENT_COMMENT = "SET_ITER_SUB_REQUIREMENT_COMMENT",
}

export const focusFeedback: Record<string, string> = {
  execution: "Execution",
  leadership: "Leadership",
  knowledgeBase: "Knowledge Base",
  communication: "Communication",
};

export const STEPS = {
  REQUEST: "Request",
  REQUEST1: "Request1",
  REQUEST2: "Request2",
  PERFORM: "Perform",
  REFLECT: "Reflect",
  REFLECT_COACH: "ReflectCoach",
  SUBMIT: "Submit",
};

export const SKIP_REVIEW_EPA_SUMMARY_STORAGE_KEY =
  "requestFeedback.skipReviewEpaSummary";

// 20 hours
export const DELTA_TIME_DUE = 20 * 60 * 60 * 1000;
